module.exports = __webpack_public_path__ + "nunito-sans-latin-400italic.d44697ce7f31cee44f701572fb38cab5.woff2";